function initStageMagnifier(stage, getActiveThumb, getActiveStageImage) {
  if (!stage) return null;
  var zoomPane = stage.querySelector('[data-cs-pi-zoom-pane]');
  if (!zoomPane) return null;
  if (!window.matchMedia('(min-width: 1101px) and (hover: hover)').matches) return null;

  var ZOOM_SCALE = 2.5;

  function escapeCssUrl(url) {
    return String(url).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function syncZoomSource() {
    var thumb = getActiveThumb ? getActiveThumb() : null;
    var stageImage = getActiveStageImage ? getActiveStageImage() : null;
    var zoomSrc =
      (thumb && thumb.getAttribute('data-zoom-src')) ||
      (stageImage && stageImage.getAttribute('data-zoom-src')) ||
      (stageImage && (stageImage.currentSrc || stageImage.src));
    if (!zoomSrc) return;
    zoomPane.style.backgroundImage = 'url("' + escapeCssUrl(zoomSrc) + '")';
  }

  function setZoomEnabled(enabled) {
    stage.classList.toggle('cs-pi-stage--zoomable', enabled);
    if (!enabled) stage.classList.remove('is-magnifying');
  }

  function onMove(event) {
    var rect = stage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = ((event.clientX - rect.left) / rect.width) * 100;
    var y = ((event.clientY - rect.top) / rect.height) * 100;
    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));
    zoomPane.style.backgroundPosition = x + '% ' + y + '%';
    zoomPane.style.backgroundSize = ZOOM_SCALE * 100 + '%';
  }

  stage.addEventListener('mouseenter', function () {
    if (!stage.classList.contains('cs-pi-stage--zoomable')) return;
    syncZoomSource();
    stage.classList.add('is-magnifying');
  });
  stage.addEventListener('mousemove', onMove);
  stage.addEventListener('mouseleave', function () {
    stage.classList.remove('is-magnifying');
  });

  return { syncZoomSource: syncZoomSource, setZoomEnabled: setZoomEnabled };
}

class CsProductGallery extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.csPiReady) {
      this.dataset.csPiReady = 'true';

      var root = this;

      var variantMediaScript = root.parentElement ? root.parentElement.querySelector('[data-cs-pi-variant-media]') : null;
      var variantMediaMap = [];
      if (variantMediaScript) {
        try {
          variantMediaMap = JSON.parse(variantMediaScript.textContent);
        } catch (e) {}
      }

      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cs-pi-thumb]'));
      var thumbsTrack = root.querySelector('[data-cs-pi-thumbs-track]');
      var stagePrev = root.querySelector('[data-cs-pi-stage-prev]');
      var stageNext = root.querySelector('[data-cs-pi-stage-next]');
      var thumbsPrev = root.querySelector('[data-cs-pi-thumbs-prev]');
      var thumbsNext = root.querySelector('[data-cs-pi-thumbs-next]');
      var productId = root.getAttribute('data-product-id');
      var activeIndex = 0;
      var stage = root.querySelector('[data-cs-pi-stage]') || root.querySelector('.cs-pi-stage');
      var magnifier = initStageMagnifier(stage, function () {
        return thumbs[activeIndex];
      }, function() {
        return root.querySelector('.cs-pi-stage-image.is-active');
      });

      if (!thumbs.length) return;

      thumbs.forEach(function (thumb, index) {
        if (thumb.classList.contains('is-active')) activeIndex = index;
      });



      function scrollThumbIntoView(thumb) {
        if (!thumbsTrack || !thumb) return;
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      function scrollThumbsBy(direction) {
        if (!thumbsTrack) return;
        var isLeftLayout = root.getAttribute('data-layout') === 'left' && window.matchMedia('(min-width: 1101px)').matches;
        if (isLeftLayout) {
          var step = Math.max(thumbsTrack.clientHeight * 0.85, 200);
          thumbsTrack.scrollBy({ top: direction * step, behavior: 'smooth' });
        } else {
          var step = Math.max(thumbsTrack.clientWidth * 0.85, 200);
          thumbsTrack.scrollBy({ left: direction * step, behavior: 'smooth' });
        }
      }

      function updateThumbsScrollNav() {
        if (!thumbsTrack) return;
        var isLeftLayout = root.getAttribute('data-layout') === 'left' && window.matchMedia('(min-width: 1101px)').matches;
        var maxScroll = isLeftLayout 
          ? thumbsTrack.scrollHeight - thumbsTrack.clientHeight
          : thumbsTrack.scrollWidth - thumbsTrack.clientWidth;
          
        if (maxScroll <= 2) {
          if (thumbsPrev) thumbsPrev.disabled = true;
          if (thumbsNext) thumbsNext.disabled = true;
          return;
        }
        
        var currentScroll = isLeftLayout ? thumbsTrack.scrollTop : thumbsTrack.scrollLeft;
        
        if (thumbsPrev) thumbsPrev.disabled = currentScroll <= 2;
        if (thumbsNext) thumbsNext.disabled = currentScroll >= maxScroll - 2;
      }

      function updateNavState() {
        var atStart = activeIndex <= 0;
        var atEnd = activeIndex >= thumbs.length - 1;
        if (stagePrev) stagePrev.disabled = atStart;
        if (stageNext) stageNext.disabled = atEnd;
        updateThumbsScrollNav();
      }

      function goToIndex(index, options) {
        var opts = options || {};
        if (!thumbs.length) return;
        if (index < 0) index = thumbs.length - 1;
        if (index >= thumbs.length) index = 0;
        activeIndex = index;

        var thumb = thumbs[activeIndex];
        thumbs.forEach(function (button, i) {
          var isActive = i === activeIndex;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        // update stage image
        var stageImages = Array.prototype.slice.call(root.querySelectorAll('.cs-pi-stage-image'));
        var mediaId = thumb ? thumb.getAttribute('data-media-id') : null;
        
        stageImages.forEach(function (img) {
          if (img.getAttribute('data-media-id') === mediaId) {
            img.classList.add('is-active');
          } else {
            img.classList.remove('is-active');
          }
        });
        
        var mediaType = thumb.getAttribute('data-media-type');
        var zoomEnabled = !mediaType || mediaType === 'image';
        if (magnifier) {
          magnifier.setZoomEnabled(zoomEnabled);
          if (zoomEnabled) magnifier.syncZoomSource();
        }

        if (opts.scrollThumb !== false) scrollThumbIntoView(thumb);
        updateNavState();
      }

      function goToMediaId(mediaId) {
        if (!mediaId) return;
        var id = String(mediaId);
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('data-media-id') === id) {
            goToIndex(i);
            return true;
          }
        }
        return false;
      }

      root.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-cs-pi-thumb]');
        if (thumb && root.contains(thumb)) {
          event.preventDefault();
          var index = thumbs.indexOf(thumb);
          if (index >= 0) goToIndex(index);
          return;
        }

        if (event.target.closest('[data-cs-pi-stage-prev]')) {
          event.preventDefault();
          goToIndex(activeIndex - 1);
          return;
        }
        if (event.target.closest('[data-cs-pi-stage-next]')) {
          event.preventDefault();
          goToIndex(activeIndex + 1);
          return;
        }
        if (event.target.closest('[data-cs-pi-thumbs-prev]')) {
          event.preventDefault();
          scrollThumbsBy(-1);
          return;
        }
        if (event.target.closest('[data-cs-pi-thumbs-next]')) {
          event.preventDefault();
          scrollThumbsBy(1);
        }
      });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToIndex(activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToIndex(activeIndex + 1);
        }
      });

      var touchStartX = null;
      if (stage && thumbs.length > 1) {
        stage.addEventListener(
          'touchstart',
          function (event) {
            touchStartX = event.changedTouches[0].screenX;
          },
          { passive: true }
        );
        stage.addEventListener(
          'touchend',
          function (event) {
            if (touchStartX == null) return;
            var delta = event.changedTouches[0].screenX - touchStartX;
            touchStartX = null;
            if (Math.abs(delta) < 40) return;
            goToIndex(delta > 0 ? activeIndex - 1 : activeIndex + 1);
          },
          { passive: true }
        );
      }

      this.boundVariantSelected = function (event) {
        var optionValueId = event.detail && event.detail.resource && event.detail.resource.id;
        if (!optionValueId) return;
        
        var selectedOption = event.target.querySelector('[data-option-value-id="' + optionValueId + '"]');
        if (!selectedOption) return;
        
        var variantId = selectedOption.getAttribute('data-variant-id');
        if (!variantId) return;

        var match = variantMediaMap.find(function (item) {
          return String(item.id) === String(variantId);
        });
        if (match && match.media_id) {
          goToMediaId(match.media_id);
        }
      };
      if (thumbsTrack) {
        thumbsTrack.addEventListener('scroll', updateThumbsScrollNav, { passive: true });
      }

      updateNavState();
      if (magnifier && thumbs[activeIndex]) {
        var initialType = thumbs[activeIndex].getAttribute('data-media-type');
        magnifier.setZoomEnabled(!initialType || initialType === 'image');
        magnifier.syncZoomSource();
      }
      this.boundResize = updateThumbsScrollNav;
    }

    if (this.boundVariantSelected) {
      document.addEventListener('variant:selected', this.boundVariantSelected);
    }
    if (this.boundResize) {
      window.addEventListener('resize', this.boundResize);
    }
  }

  disconnectedCallback() {
    if (this.boundVariantSelected) {
      document.removeEventListener('variant:selected', this.boundVariantSelected);
    }
    if (this.boundResize) {
      window.removeEventListener('resize', this.boundResize);
    }
  }
}

if (!customElements.get('cs-product-gallery')) {
  customElements.define('cs-product-gallery', CsProductGallery);
}
